module.exports = __webpack_public_path__ + "bw.6c2cdb0c.svg";